import script from "./DailyCampaignTypeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyCampaignTypeTable.vue?vue&type=script&setup=true&lang=js"

import "./DailyCampaignTypeTable.vue?vue&type=style&index=0&id=6b1b2d94&lang=css"

const __exports__ = script;

export default __exports__